import React from  'react';
import './Navbar.component.scss';

export const Navbar:React.FC = () => {

  return (
  <div className='navbar-container d-flex justify-content-center'>
    <div className='navbar-links px-2 d-flex justify-content-end align-items-center'>
      <a href='https://www.pin-ag.de/faq' target="_self">FAQ</a>
      <div className='navbar-divider'></div>
      <a href='https://www.pin-ag.de/servicecenter' target="_self">Kontakt</a>
    </div>
  </div>
  )
}